import onboarding from "@/services/onboarding";
import accountExtensions from "@/services/account.extensions";
import router from "../router";
import authStore from "./auth";

const hasTopup = (value) => authStore.state.enabledTopUps.includes(value);

export default {
  namespaced: true,
  state: {
    payoutRequirementsBack: false,
    proofOfBankingError: false,
    governmentIdError: false,
    otherGovenmentDocuError: false,
    stayReminderModal: false,
    onboardingModuleCompleted: false,
    formBankDetails: null,
    bankDetails: null,
    fulfillmentSettings: {
      "level": "merchant",
      "deliver_now": {
        "delivery_fee_type": "fixed",
        "base_fee_value": null,
        "base_km_range": null,
        "added_value_per_km": null,
        "enable_minimum_spend": 0,
        "minimum_spend_amount": 0,
        "minimum_spend_currency": "PHP"
      },
      "scheduled_delivery": {
        "same_deliver_now": false,
        "delivery_fee_type": null,
        "base_fee_value": null,
        "base_km_range": null,
        "added_value_per_km": null,
        "enable_minimum_spend": false,
        "minimum_spend_amount": null,
        "minimum_spend_currency": null
      }
    },
    fulfillmentStatus: {
      "delivery": {
        "deliver_now": 'false',
        "scheduled": 'false'
      },
      "pickup": {
        "pickup_now": 'false',
        "scheduled": 'false'
      }
    },
    merchantStatus: {
      "total_progress": "0",
      "total_done": 0,
      "total_overall": 6,
      "progress": [
        {
          "step": "1",
          "step_status": "Not yet Started",
          "substeps": [
            {
              "sub": "1.1",
              "status": "Not yet Started"
            },
            {
              "sub": "1.2",
              "status": "Not yet Started"
            },
            {
              "sub": "1.3",
              "status": "Not yet Started"
            }
          ]
        },
        {
          "step": "2",
          "step_status": "Not yet Started",
          "substeps": [
            {
              "sub": "2.1",
              "status": "Not yet Started"
            },
            {
              "sub": "2.2",
              "status": "Not yet Started"
            }
          ]
        },
        {
          "step": "3",
          "step_status": "Not yet Started",
          "substeps": [
            {
              "sub": "3.1",
              "status": "Not yet Started"
            }
          ]
        }
      ]
    },
    onboardingFormErrors: {
      locationName: false,
      branchAddress: false,
      province: false,
      city: false,
      contactNumber: false,
      longitude: false,
      latitude: false
    },
    navigationBar: {
      "all": false,
      "estore": false
    },
    toast: false,
    toastValue: '',
    onboardingError: false,
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    provinces: null,
    cities: null,
    branch: null,
    base64String: [],
    moduleAvailableModal: false,
    startSelling: false,
    startSellingModal: false,
    logisticError: false,
    fulfillmentFeesError: false,
    bankRequirementsFormErrors: {
      "name": false,
      "address": false,
      "mobile_number": false,
      "email_address": false,
      "tin_number": false,
      "bank_name": false,
      "bank_address": false,
      "bank_account_currency": false,
      "bank_account_number": false,
      "bank_account_name": false,
      "bank_swift_code": false,
      "documents": false
    },
    bankValidEmail: false,
    minimumNumberError: false,
    minimumAccountNumberError: false,
    hasInitializedMerchantSetup: false,
    locationContacNumberRequired: false,
    locationContactNumberInvalid: false,
    payoutRequirementsContactNumberInvalid: false,
    isModuleAvailableModalFirstTime: true,
    liveSellingModal: false,
    coordinatesEmptyError: false,
    isLoading: false,
    errors: null,
    isExistingSubdomain: false,
  },
  mutations: {
    setCoordinatesEmptyError(state, value) {
      state.coordinatesEmptyError = value
    },
    setIsModuleAvailableModalFirstTime(state, value) {
      state.isModuleAvailableModalFirstTime = value
    },
    setPayoutRequirementsContactNumberInvalid(state, value) {
      state.payoutRequirementsContactNumberInvalid = value
    },
    setLocationContactNumberInvalid(state, value) {
      state.locationContactNumberInvalid = value
    },
    setLocationContactNumberRequired(state, value) {
      state.locationContacNumberRequired = value
    },
    setMinimumAccountNumberError(state, value) {
      state.minimumAccountNumberError = value
    },
    setMinimumNumberError(state, value) {
      state.minimumNumberError = value
    },
    setEmailErrorToFalse(state) {
      state.bankRequirementsFormErrors.email_address = false
    },
    setBankValidEmail(state, value) {
      state.bankValidEmail = value
    },
    setPayoutRequirementsBack(state, value) {
      state.payoutRequirementsBack = value
    },
    setOnboardingFormContactNumberError(state, value) {
      state.onboardingFormErrors.contactNumber = value
    },
    setBase64String(state, value) {
      state.base64String = value
    },
    setProofOfBankingError(state, value) {
      state.proofOfBankingError = value
    },
    setOtherGovenmentDocuError(state, value) {
      state.otherGovenmentDocuError = value
    },
    setGovernmentIdError(state, value) {
      state.governmentIdError = value
    },
    setStayReminderModal(state, value) {
      state.stayReminderModal = value
    },
    setBankRequirementsFormErrors(state, value) {
      for (const key in value) {
        if (key.includes('documents') && key.includes('.file')) {
          state.proofOfBankingError = true
          state.governmentIdError = true
          state.otherGovenmentDocuError = true
        }
      }

      if (value !== false) {
        if (value.name) {
          state.bankRequirementsFormErrors.name = true
        }
        if (value.address) {
          state.bankRequirementsFormErrors.address = true
        }
        if (value.mobile_number) {
          state.bankRequirementsFormErrors.mobile_number = true
        }
        if (value.email_address) {
          state.bankRequirementsFormErrors.email_address = true
        }
        if (value.tin_number) {
          state.bankRequirementsFormErrors.tin_number = true
        }
        if (value.bank_address) {
          state.bankRequirementsFormErrors.bank_address = true
        }
        if (value.bank_account_currency) {
          state.bankRequirementsFormErrors.bank_account_currency = true
        }
        if (value.bank_name) {
          state.bankRequirementsFormErrors.bank_name = true
        }
        if (value.bank_account_number) {
          state.bankRequirementsFormErrors.bank_account_number = true
        }
        if (value.bank_account_name) {
          state.bankRequirementsFormErrors.bank_account_name = true
        }
        if (value.bank_swift_code) {
          state.bankRequirementsFormErrors.bank_swift_code = true
        }
        if (value.documents) {
          state.bankRequirementsFormErrors.documents = true
          state.proofOfBankingError = true
          state.governmentIdError = true
          state.otherGovenmentDocuError = true
        }

      }
      else {
        state.bankRequirementsFormErrors = {
          "name": false,
          "address": false,
          "mobile_number": false,
          "email_address": false,
          "tin_number": false,
          "bank_name": false,
          "bank_address": false,
          "bank_account_currency": false,
          "bank_account_number": false,
          "bank_account_name": false,
          "bank_swift_code": false,
          "documents": false
        }
      }
    },
    setFulfillmentFeesError(state, value) {
      state.fulfillmentFeesError = value
    },
    setLogisticError(state, value) {
      state.logisticError = value
    },
    setOnboardStatusValue(state, value) {
      state.onboardingStatusValue = value;
    },
    setMerchantStatus(state, value) {
      state.merchantStatus = value;
    },
    setOnboardingError(state, value) {
      state.onboardingError = value;
    },
    setLoading1(state, value) {
      state.loading1 = value
    },
    setLoading2(state, value) {
      state.loading2 = value
    },
    setLoading3(state, value) {
      state.loading3 = value
    },
    setLoading4(state, value) {
      state.loading4 = value
    },
    setProvinces(state, value) {
      state.provinces = value
    },
    setCities(state, value) {
      state.cities = value
    },
    setBranch(state, value) {
      state.branch = value
    },
    setToast(state, value) {
      state.toast = value
    },
    setToastValue(state, value) {
      state.toastValue = value
    },
    setFulfillmentStatus(state, value) {
      state.fulfillmentStatus = value
    },
    setFulfillmentSettings(state, value) {
      state.fulfillmentSettings = value
    },
    setBankDetails(state, value) {
      state.bankDetails = value
    },
    setFormBankDetails(state, value) {
      state.formBankDetails = value
    },
    setBase64File(state, payload) {
      const isSimilar = state.base64String.some((item) => item.type === payload.type);
      if (isSimilar) {
        state.base64String = state.base64String.map((item) => {
          return item.type === payload.type ? payload : item;
        });
      } else {
        state.base64String.push(payload)
      }
    },
    setModuleAvailableModal(state, value) {
      state.moduleAvailableModal = value
    },
    setNavigationBar(state, value) {
      state.navigationBar.all = value
    },
    setStartSelling(state, value) {
      state.startSelling = value
    },
    setStartSellingModal(state, value) {
      state.startSellingModal = value
    },
    removeBase64String(state, typeToRemove) {
      const indexToRemove = state.base64String.findIndex(item => item.type === typeToRemove);
      if (indexToRemove !== -1) {
        state.base64String.splice(indexToRemove, 1);
      }
    },
    setNavigationBarStore(state, value) {
      state.navigationBar.estore = value
    },
    setOnboardingFormErrors(state, value) {
      if (value !== false) {
        if (value.street) {
          state.onboardingFormErrors.branchAddress = true
        }
        if (value.province) {
          state.onboardingFormErrors.province = true
        }
        if (value.city) {
          state.onboardingFormErrors.city = true
        }
        if (value.name) {
          state.onboardingFormErrors.locationName = true
        }
        if (value.branch_mobile) {
          state.onboardingFormErrors.contactNumber = true
        }
        if (value.longitude) {
          state.onboardingFormErrors.longitude = true
        }
        if (value.latitude) {
          state.onboardingFormErrors.latitude = true
        }
      }
      else {
        state.onboardingFormErrors = {
          locationName: false,
          branchAddress: false,
          province: false,
          city: false,
          longitude: false,
          latitude: false
        }
      }

    },
    setOnboardingModuleCompleted(state, value) {
      state.onboardingModuleCompleted = value
    },
    setHasInitializedMerchantSetup(state, value) {
      state.hasInitializedMerchantSetup = value
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setErrors(state, value) {
      state.errors = value;
    },
    setIsExistingSubdomain(state, value) {
      state.isExistingSubdomain = value;
    },
  },

  actions: {
    setMapErrorOnLoad({ commit }) {
      try {
        commit("setOnboardingError", true)
        commit("setToast", true)
        commit('setToastValue', 'Error during loading please reload')

      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        setTimeout(() => {
          commit("setToast", false)
          commit('setToastValue', '')
          commit('setLoading2', false)
          commit("setOnboardingError", false)
        }, 3000)
      }
    },
    setCoordinatesError({ commit }) {
      try {
        commit("setOnboardingError", true)
      }
      catch {
        console.log("error in setting coordinates")
      }
      finally {
        setTimeout(() => {
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
        }, 3000)
      }
    },
    setError({ commit }, { value }) {
      try {
        commit('setToast', true)
        commit("setToastValue", value)
        commit("setOnboardingError", true)
      }
      catch {
        console.log("error in setError")
      }
      finally {
        setTimeout(() => {
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
        }, 3000)
      }
    },
    async getMerchantSetup({ commit }) {
      try {
        const data = await onboarding.getMerchantSetup();

        if ("total_progress" in data) {
          commit('setMerchantStatus', data)
          commit('setHasInitializedMerchantSetup', true);
        } else {
          console.log("No message key in the API response.");
        }
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getProvinces({ commit }) {
      try {
        const data = await onboarding.getProvinces();
        commit("setProvinces", data.data)
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getCities({ commit }, params) {

      try {
        const data = await onboarding.getCities(params);
        commit("setCities", data.data)

      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getBranchList({ commit }) {

      try {
        const data = await onboarding.getBranchList();
        commit('setBranch', data.length ? data[0] : null);
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getWebList({ commit }) {
      try {
        await onboarding.getWebList();
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getFulfillment({ commit }) {
      try {
        const data = await onboarding.getFulfillment();
        if ("delivery" in data) {
          commit('setFulfillmentStatus', data)
        } else {
          console.log("No delivery key in the API response.");
        }

      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async updateFulfillment({ commit }, { payload }) {
      commit('setLoading2', true)
      try {
        await onboarding.updateFulfillment(payload);
        commit("setToast", true)
        commit('setToastValue', 'Settings saved!')
        commit('setLogisticError', false)
        commit('setLoading2', false)
      } catch (errors) {
        commit('setLogisticError', true)
        commit('setLoading2', false)
      } finally {
        setTimeout(() => {
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
          commit('setLoading2', false)
        }, 3000)
      }

    },
    async getFulfillmentFees({ commit }) {
      try {
        const data = await onboarding.getFulfillmentFees();
        if ("data" in data) {
          commit('setFulfillmentSettings', data.data)
        } else {
          console.log("No data key in the API response.");
        }
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async saveFulfillmentFeesSettings({ commit }, { payload }) {
      commit('setLoading3', true)
      try {
        await onboarding.saveFulfillmentFeesSettings(payload);
        commit("setToast", true)
        commit('setToastValue', 'Settings saved!')
        commit('setFulfillmentFeesError', false)
        commit('setLoading3', false)
      } catch (errors) {
        commit('setFulfillmentFeesError', true)
        commit('setLoading3', false)
      } finally {
        setTimeout(() => {
          commit('setLoading3', false)
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
        }, 3000)
      }
    },
    async getPayoutDetails({ commit }) {
      try {
        const data = await onboarding.getPayoutDetails();
        commit('setBankDetails', data.data)
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async updatePayoutDetails({ commit }, { payload }) {
      commit('setLoading1', true)
      try {
        await onboarding.updatePayoutDetails(payload);
        commit("setToast", true)
        commit('setToastValue', 'Settings saved!')
        commit('setBankRequirementsFormErrors', false)
        commit('setLoading1', false)
        commit('otherGovenmentDocuError', false)
        commit('setProofOfBankingError', false)
        commit('setGovernmentIdError', false)
        router.push('/onboarding')
      } catch (errors) {
        commit('setBankRequirementsFormErrors', errors.errors)
        commit('setLoading1', false)
      } finally {
        setTimeout(() => {
          commit('setLoading1', false)
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
        }, 3000)
      }
    },
    async updateBranch({ commit }, { uuid, params }) {
      commit('setLoading1', true)
      try {
        await onboarding.updateBranch(uuid, params);
        commit("setToastValue", 'Settings saved!')
        commit("setToast", true)
        commit("setOnboardingFormErrors", false)
        commit("setLocationContactNumberRequired", false)
        commit('setLoading1', false)
      } catch (error) {
        commit('setLoading1', false)
        commit("setOnboardingFormErrors", error.errors)
      } finally {
        commit('setLoading1', false)
        setTimeout(() => {
          commit("setToast", false)
          commit("setOnboardingError", false)
        }, 3000)
      }
    },
    async getFulfillmentSetupList({ commit }) {
      try {
        await onboarding.getFulfillmentSetupList();
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async goLiveWebsite({ commit }) {
      commit('setLoading4', true)
      try {
        await onboarding.goLiveWebsite();
        commit("setToast", true)
        commit('setToastValue', 'Settings saved!')
        commit('setLoading4', false)
      } catch (errors) {
        commit('setLoading4', false)
      } finally {
        setTimeout(() => {
          commit("setToast", false)
          commit("setOnboardingError", false)
          commit('setToastValue', '')
          commit('setLoading4', false)
        }, 3000)
      }
    },
    async checkSubdomain({ commit }, subdomain) {
      commit("setIsLoading", true);
      commit("setErrors", null);

      try {
        const response = await accountExtensions.checkSubdomain({
          payload: { subdomain }
        });

        commit("setIsExistingSubdomain", response.exists);

      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setIsLoading", false);
      }
    },
    async updateSubdomain({ commit }, subdomain) {
      commit("setIsLoading", true);
      commit("setErrors", null);

      try {
        await accountExtensions.updateSubdomain({
          payload: { subdomain }
        });

        commit("setToast", true)
        commit('setToastValue', 'Settings saved!')
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setIsLoading", false);
        setTimeout(() => {
          commit("setToast", false)
          commit('setToastValue', '')
        }, 3000)
      }
    },
    async saveMerchantSetup({ commit }, payload) {
      commit('setLoading1', true);

      try {
        await onboarding.saveMerchantSetup(payload);
      } catch (error) {
        commit("setOnboardingFormErrors", error.errors)
      } finally {
        commit('setLoading1', false);
      }
    }
  },
  getters: {
    getProvinces: (state) => state.provinces,
    step1AndStep2Completed(state) {
      if (!hasTopup("estore")) return true;

      return state.merchantStatus.progress[0].step_status === "Completed" && 
      state.merchantStatus.progress[1].step_status === "Completed";
    },
    step3Completed(state) {
      return state.merchantStatus.progress[2].step_status === "Completed"
    },
    getStep1SubStep1(state) {
      return state.merchantStatus.progress[0].substeps[0].status === "Completed"
    },
    getAllStep(state) {
      return state.merchantStatus.progress[0].step_status === "Completed" && state.merchantStatus.progress[1].step_status === "Completed" && state.merchantStatus.progress[1].step_status === "Completed";
    },
    getStep2Substep2(state) {
      return state.merchantStatus.progress[1].substeps[1].status === "Completed"
    }
  },


};
